export default __webpack_public_path__ + "static/8_9-a50d23c7488c0a1bfe5cbea73de55f6e.png";